import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Grid, IconButton, List, ListItem, Paper, TextField, ThemeProvider, Tooltip, Typography, useTheme } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticData from "../../../data/StaticData";
import { DataGrid } from "@mui/x-data-grid";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";
import { MdAdd, MdDelete, MdEditSquare, MdExpandLess, MdExpandMore } from "react-icons/md";
import staticVariablesApi from "../../../api/staticVariablesApi";

const EditFlightComNutrition = ({ flightData }) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const { setOpen } = useContext(ContextNotification);
    const customization = useSelector((state) => state.customization);
    const [isloading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [brokers, setBrokers] = useState([]);
    const [freePassengers, setFreePassengers] = useState([]);
    const [mealTypes, setMealTypes] = useState([]);
    const [costItems, setCostItems] = useState([]);
    const schema = yup.object().shape({
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        resolver: yupResolver(schema),
    });
    const Columns = [
        {  headerName: "نام کارگزاری", width: '200',renderCell: (cellValues) =>{return cellValues.row.kargozarCode!=null? cellValues.row.kargozarCode+' - '+cellValues.row.brokerGroupCode+' - '+cellValues.row.kargozarName:''} },
        { field: "fullName", headerName: " نام مسافر آزاد", width: '150' },
        
    ];
    Columns.push({
        field: "ویرایش", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isloading}
                    sx={{ color: '#4a148c' }}
                    onClick={() => {
                        handleOpenEdit(cellValues.row)
                    }}><MdEditSquare />
                </IconButton>
            )
        }
    });
    Columns.push({
        field: "حذف", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isloading}
                    sx={{ color: '#c70c05c2' }}
                    onClick={() => {
                        handleOpenDelete(cellValues.row)
                    }}><MdDelete />
                </IconButton>
            )
        }
    });

    useEffect(() => {
        resetForm();
        setBrokers(flightData?.tripGroupMembersResponses?.filter((itm) => itm.brokerCode !== null).map((o) => {
            return {
                id: o.brokerId,
                label: o.brokerCode + '-' + o.brokerName
            };
        }));
        setFreePassengers(flightData?.tripPassengerMembersResponses?.filter(itm => (itm.flightAttendanceStatus === false)).map((o) => {
            return {
                id: o.passengerId,
                label: o.sSn + '-' + o.fullName
            };
        }));
    }
        , [flightData])
    useEffect(() => {
        GetMealTypeDropDown();
    }, []);

    const resetForm = () => {
        clearCostData();
        setSelectedCompensation(null);
        setOpenDelete(false);
        setOpenDeletecost(false);
        setDeleteData(null);
        setDeletedCost(null);
        GetData();
    }

    const GetMealTypeDropDown = () => {
        staticVariablesApi.GetMealTypeDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setMealTypes(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((error1) => {
                console.log(error1);
            })

    }

    const GetData = (selectedcostid) => {
        setRows([]);
        if (flightData?.flightId) {
            setIsLoading(true);
            FlightCompensationApi.GetFlightCompNutritionByFlightId(flightData?.flightId).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setRows(res.data.data);
                        const scompensation = (selectedcostid ? res.data.data.find(itm => itm.id === selectedcostid) : null);
                        setSelectedCompensation(scompensation);
                        if (scompensation?.flightCompensationForGroupNutritions) {
                            fillNewCostItems(scompensation.flightCompensationForGroupNutritions.map((itm, index) => {

                                return {
                                    'id': itm.mealId ? itm.mealId : null,
                                    'index': index,
                                    'mealType': String(itm.mealType),
                                    'mealRate': String(itm.mealRate),
                                    'description':String(itm.description)
                                }
                            }));
                        }
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در دریافت اطلاعات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setIsLoading(false) });
        }
    }
    ////costs/////////////////////////////////////

    const [errorRequiredIndex, setErrorRequiredIndex] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(false);

    const clearCostData = () => {

        setOpenDropdown(true);
        setErrorRequiredIndex([]);
         var costdata = {
                'id': null,
                'index':  0,
                'mealType':null,
                'mealRate': null,
                'description': "",
            }

            fillNewCostItems([costdata]);
            setOpenDropdown(true);
        setOpenDelete(false);
        setDeleteData(null);
    }
    const resetCostData = (selectedcost) => {
        GetData(selectedcost?.id);
        setOpenDropdown(true);
    }
     const AddNewRow = () => {

        if ((selectedCompensation === null) || (selectedCompensation.flightCompensationForGroupNutritions?.length === costItems.length)) {
            var maxindex = costItems.length > 0 ? Math.max(...costItems.map(a => { return a.index })) : 0;
            var costdata = {
                'id': null,
                'index': maxindex + 1,
                'mealType': null,
                'mealRate': null,
                'description': "",
            }

            fillNewCostItems([...costItems, costdata]);
            setOpenDropdown(true);
        }

    }
  
    const fillNewCostItems = (costdata) => {
        setCostItems(costdata);
        var errors = [];
        costdata.map((itm, index) => {
            setValue('mealType' + String(itm.index), itm.mealType);
            setValue('mealRate' + String(itm.index), itm.mealRate);
            setValue('description' + String(itm.index), itm.description);
            if (itm.mealType === null) errors = [...errors, { "index": itm.index, "value": "mealType" }];
            if (itm.mealRate === null) errors = [...errors, { "index": itm.index, "value": "mealRate" }];
        });
        setErrorRequiredIndex(errors);

    }


    const EditCost = (costdata) => {
        var pmealType = costdata.mealType;
        var pmealRate = costdata.mealRate;
        var pdescription = costdata.description ?? '';
        const editcostdata = {
            'mealType': parseInt(pmealType),
            'mealRate': parseInt(pmealRate),
            'description': pdescription,

        }

        if ((!errorRequiredIndex.some(itm => itm.index === costdata.index)) && (costdata.id !== null))//edit cost
        {

            setIsLoading(true);
            FlightCompensationApi.UpdateMeal(costdata.id, editcostdata).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت ویرایش شد', severity: severitys.success });
                        resetCostData(selectedCompensation);
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }

            }).catch(err => {

                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => {
                setIsLoading(false);
            });

        }
        else//add cost
        {
            if ((!errorRequiredIndex.some(itm => itm.index === costdata.index)) && (selectedCompensation?.id)) {

                setIsLoading(true);
                FlightCompensationApi.AddMeal(selectedCompensation?.id, editcostdata).then(res => {
                    if (res.status === 200) {
                        if (res.data.success) {
                            setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت افزوده شد', severity: severitys.success });
                            resetCostData(selectedCompensation);
                        }
                        else {
                            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                        }
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }

                }).catch(err => {

                    if (err.response && err.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data && err.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                    }

                }).finally(() => {
                    setIsLoading(false);
                });

            }

        }

    }


    ///delete/////////////////////////////////////
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteData, setDeleteData] = useState(null);
    const handleOpenDelete = (data) => {
        setOpenDelete(true);
        setDeleteData(data);
    };
    const handleDeleteRow = () => {
        setIsLoading(true);
        FlightCompensationApi.deleteFlightCompNutrition(deleteData.id).then(res => {
            if (res.status === 200) {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت حذف شد', severity: severitys.success });
                    resetForm();
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

                }

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            setOpenDelete(false);
        });
    }
    //////deleteCost
    const [openDeletecost, setOpenDeletecost] = useState(false);
    const [deletedCost, setDeletedCost] = useState(null);
    const handlecloseDeleteCost = () => {
        setOpenDeletecost(false);
        setDeletedCost(null);
    }
    const DeleteCost = (costitem) => {
        if (costitem.id !== null) {
            setDeletedCost(costitem);
            setOpenDeletecost(true);
        }
        else {
            fillNewCostItems(costItems?.filter((itm) => itm.index !== costitem.index));
        }
    }
    const handleDeleteCost = () => {

        setIsLoading(true);
        FlightCompensationApi.deleteMeal(deletedCost.id).then(res => {
            if (res.status === 200) {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: 'هزینه مورد نظر با موفقیت حذف شد', severity: severitys.success });
                    resetCostData(selectedCompensation);
                    handlecloseDeleteCost();

                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            setOpenDeletecost(false);
        });

    }


    ////////Edit/////////////////////////
    const [selectedCompensation, setSelectedCompensation] = useState(null);
    const handleOpenEdit = (data) => {
        if (selectedCompensation?.id === data.id) {
            setSelectedCompensation(null);
            clearCostData();

        }
        else {
            resetCostData(data);
        }
    }
    ////////////////////////

    const DoSave = (data) => {
        var pbrokerGroupNo = null;
        var pbrokerID = null;
        if (data.brokerID) {
            var broker = flightData?.tripGroupMembersResponses?.find((itm) => itm.brokerId === data.brokerID);
            pbrokerGroupNo = String(broker.groupNo);
            pbrokerID = String(data.brokerID);
        }
        var ppassengerId = null;
        if (data.passengerID)
            ppassengerId = String(data.passengerID);


        if ((costItems?.length > 0) && ((pbrokerID !== null) || (ppassengerId !== null)) && (errorRequiredIndex.length === 0)) {
            const compdata = {
                "brokerId": pbrokerID,
                "passengerId": ppassengerId,
                "brokerGroupNo": pbrokerGroupNo,
                "fcMealsList": costItems.map((itm) => {
                    return {
                        "mealType": parseInt(itm.mealType),
                        "mealRate": parseInt(itm.mealRate),
                        "description": itm.description,
                    }
                })
            }
            setSubmitLoading(true);

            if (selectedCompensation === null)//add mode
            {
                FlightCompensationApi.AddFlightCompNutrition(flightData?.flightId, compdata).then(res => {
                    if (res.status === 200) {
                        if (res.data.success) {
                            setOpen({ IsEnable: true, Message: 'هزینه با موفقیت افزوده شد', severity: severitys.success });
                            resetForm();

                        }
                        else {
                            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                        }
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                    }

                }).catch(err => {

                    if (err.response && err.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data && err.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                    }

                }).finally(() => { setSubmitLoading(false) });
            }

        }
    }

    const handlebrokerIDChanged = () => {


        if ((watch("brokerID")) && (watch("brokerID") !== null)) {
            setValue("passengerID", null);
        }

    }
    const handlepassengerIDChanged = () => {
        if ((watch("passengerID")) && (watch("passengerID") !== null)) {
            setValue("brokerID", null);
        }

    }
    const handleChangeMealType = (value, costItem) => {
        costItem.mealType = value;
        if (value !== null) {
            setErrorRequiredIndex(errorRequiredIndex.filter(item => ((item.index !== costItem.index) || (item.value !== "mealType"))));
        }

        else {
            setErrorRequiredIndex([...errorRequiredIndex.filter(item => ((item.index !== costItem.index) || (item.value !== "mealType"))), { "index": costItem.index, "value": "mealType" }]);
        }


    }
    const handleChangeMealRate = (value, costItem) => {
        costItem.mealRate = null;
        if ((value !== null) && (parseInt(value) > 0)) {
            costItem.mealRate = value;
            setErrorRequiredIndex(errorRequiredIndex.filter(item => ((item.index !== costItem.index) || (item.value !== "mealRate"))));
        }

        else {

            setValue("mealRate" + String(costItem.index), null);
            setErrorRequiredIndex([...errorRequiredIndex?.filter(item => ((item.index !== costItem.index) || (item.value !== "mealRate"))), { "index": costItem.index, "value": "mealRate" }]);
        }


    }
    const handlechangeDescription = (value, costItem) => {
        costItem.description = value;
    }
    return (
        <Box sx={{ m: 2 }}>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                    <form onSubmit={handleSubmit(DoSave)}>
                        <Grid container spacing={1} m={1}>
                            <Grid container spacing={1} m={1}>
                                {(selectedCompensation === null) && <>  
                                <Grid item md={2.5} xs={7}>
                                    <RHFAutocomplete
                                    
                                        control={control}
                                        options={brokers ?? []}
                                        name="brokerID"
                                        onChange={handlebrokerIDChanged}
                                        placeholder="گروه"
                                        style={{
                                            border: "none",
                                            padding: 0
                                        }}
                                    />
                                </Grid>
                                    <Grid item md={2.5} xs={7}>
                                        <RHFAutocomplete
                                            control={control}
                                            options={freePassengers ?? []}
                                            name="passengerID"
                                            onChange={handlepassengerIDChanged}
                                            placeholder="مسافر آزاد"
                                            style={{
                                                border: "none",
                                                padding: 0
                                            }}
                                        />
                                    </Grid></>}
                                {
                                    (selectedCompensation?.kargozarCode) && <Typography sx={{ m: 1 }}>{selectedCompensation?.kargozarCode + '-' + selectedCompensation?.kargozarName}</Typography>
                                }
                                {
                                    (selectedCompensation?.fullName) && <Typography sx={{ m: 1 }}>{selectedCompensation?.fullName}</Typography>
                                }
                                <Tooltip title="افزودن هزینه">
                                    <IconButton edge="end" aria-label={'افزودن'} onClick={() => AddNewRow()}>
                                        <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                        <MdAdd size={24} />
                                    </IconButton>
                                </Tooltip>

                                {costItems?.length > 0 && <IconButton edge="end" aria-label="مشاهده وعده های غذایی" onClick={() => { setOpenDropdown((old) => !old) }}>
                                    {openDropdown ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
                                </IconButton>}
                            </Grid>
 {(selectedCompensation===null)&&((!watch("brokerID"))||(watch("brokerID")===null))&&((!watch("passengerID"))||(watch("passengerID")===null)) &&
                                                            <p className="error">{' شماره گروه یا  مسافر آزاد را مشخص کنید'}</p>
                                                        }

                            {(openDropdown) && <List sx={{ width: '100%' }}>
                                {costItems?.sort((a, b) => a.index >= b.index ? 1 : -1).map((item) => {
                                    return (
                                        <Box sx={{ bgcolor: '#F1F1E8', borderRadius: 4, width: '100%' }}>
                                            <ListItem>
                                                <Grid container spacing={1}>
                                                    <Grid item md={2.5} xs={7} >
                                                        <RHFAutocomplete
                                                            control={control}
                                                            options={mealTypes ?? []}
                                                            disabled={(item.id!==null)}
                                                            name={'mealType' + String(item.index)}
                                                            defaultValue={String(item.mealType)}
                                                            onChange={(event) => { handleChangeMealType(event, item); }}
                                                            placeholder="نوع وعده غذایی"
                                                            style={{
                                                                border: "none",
                                                                padding: 0
                                                            }}
                                                        />
                                                        {errorRequiredIndex?.some((itm) => ((itm.index === item.index) && (itm.value === "mealType"))) &&
                                                            <p className="error">{' نوع وعده غذایی را مشخص کنید'}</p>
                                                        }
                                                    </Grid>
                                                    <Grid item md={2.5} xs={7}>
                                                        <TextField
                                                            type="number"
                                                            label=" نرخ غذا "
                                                            focused={(item.id!==null)}
                                                            {...register("mealRate" + String(item.index))}
                                                            onChange={(event) => { handleChangeMealRate(event.target.value, item); }}
                                                            fullWidth></TextField>
                                                        {errorRequiredIndex?.some((itm) => ((itm.index === item.index) && (itm.value === "mealRate"))) &&
                                                            <p className="error">{' نرخ غذا را وارد کنید'}</p>
                                                        }
                                                    </Grid>
                                                    <Grid item md={5} xs={12}>
                                                        <TextField
                                                            label=" توضیحات "
                                                            focused={(item.id!==null)}
                                                            {...register("description" + String(item.index))}
                                                            onChange={(event) => { handlechangeDescription(event.target.value, item); }}
                                                            ></TextField>
                                                        {(selectedCompensation !== null) && <Tooltip sx={{ mt: 2 }} title="ویرایش">
                                                            <IconButton edge="end" aria-label={'ویرایش'} onClick={() => EditCost(item)}>
                                                                <BeatLoading loading={isloading} color={"#e65100"}  />
                                                                <MdEditSquare color='#4a148c' />
                                                            </IconButton>
                                                        </Tooltip>}
                                                        <Tooltip sx={{ mt: 2 }} title="حذف">
                                                            <IconButton edge="end" aria-label={'حذف'} onClick={() => DeleteCost(item)}>
                                                                <BeatLoading loading={isloading} color={"#e65100"}  />
                                                                <MdDelete color='#C7253E' />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>

                                                </Grid>


                                            </ListItem>
                                        </Box>
                                    )
                                })}
                            </List>
                            }
                            {(selectedCompensation === null)&&(costItems?.length>0) && <Grid item md={7} xs={7.5}>
                                <Button type="submit" disabled={submitLoading} sx={{ mt: 1 }} variant="contained" color="primary" fullwidth >
                                    <BeatLoading loading={submitLoading} color={"#e65100"} /> {'ثبت هزینه'}</Button>
                            </Grid>
                            }

                        </Grid>


                        <Paper sx={{ mt: 2, width: "100%", height: "500px" }}>
                            <DataGrid
                                rows={rows}
                                columns={Columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 50,
                                        },
                                    },
                                }}
                                pageSizeOptions={[25, 50, 100]}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                disableColumnSelector
                                loading={isloading}
                                sx={{
                                    backgroundColor: '#F1F1E8', // Set your desired background color    
                                    '& .MuiDataGrid-columnHeaders > div[role="row"]': {
                                        color: '#F1F1E8!important',
                                        backgroundColor: '#50a193ff!important',
                                    },
                                }}
                            />
                        </Paper >
                        <ConfirmationDialog
                            open={openDelete}
                            handleClose={() => setOpenDelete(false)}
                            deleteFunction={handleDeleteRow}
                        />
                        <ConfirmationDialog
                            open={openDeletecost}
                            handleClose={handlecloseDeleteCost}
                            deleteFunction={handleDeleteCost}
                        />
                    </form>
                </RtlProvider>
            </ThemeProvider>
        </Box >
    )
}
export default EditFlightComNutrition;